import { render, staticRenderFns } from "./cddx_open.vue?vue&type=template&id=62ea0de4&scoped=true&"
import script from "./cddx_open.vue?vue&type=script&lang=js&"
export * from "./cddx_open.vue?vue&type=script&lang=js&"
import style0 from "./cddx_open.vue?vue&type=style&index=0&id=62ea0de4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea0de4",
  null
  
)

export default component.exports